import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment/moment';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { getOrientationsList } from '../../../../actions/orientations';
import Loader from '../../../common/ui/Loader';
import { yearMonthDayFormat, dashboardNavDateFormat } from '../../../../constants/date';
import OrientationsColumn from './OrientationsColumn';

class OrientationsList extends Component {
  static propTypes = {
    orientationsList: PropTypes.array.isRequired,
    getOrientationsList: PropTypes.func.isRequired,
    selecting: PropTypes.bool,
    updateOrientation: PropTypes.func
  };

  state = {
    isLoading: false,
    startOfWeek: moment().startOf('isoweek'),
    endOfWeek: moment().endOf('isoweek')
  };

  componentDidMount () {
    const { startOfWeek } = this.state;
    const weekMonday = startOfWeek.format(yearMonthDayFormat);
    this._setDataIsLoading();
    this.props.getOrientationsList(weekMonday).then(this._setDataLoaded);
  }

  _setDataIsLoading = () => this.setState({ isLoading: true });

  _setDataLoaded = () => this.setState({ isLoading: false });

  showPreviousWeek = () => {
    const { startOfWeek, endOfWeek } = this.state;
    startOfWeek.subtract(7, 'days');
    endOfWeek.subtract(7, 'days');
    this.changeWeek(startOfWeek, endOfWeek);
  };

  showNextWeek = () => {
    const { startOfWeek, endOfWeek } = this.state;
    startOfWeek.add(7, 'days');
    endOfWeek.add(7, 'days');
    this.changeWeek(startOfWeek, endOfWeek);
  };

  changeWeek = (startOfWeek, endOfWeek) => {
    this.setState({
      startOfWeek,
      endOfWeek
    });
    this.props.getOrientationsList(startOfWeek.format(yearMonthDayFormat));
  };

  render () {
    if (this.state.isLoading) {
      return <div className='loader-wrapper'><Loader /></div>;
    }
    const { orientationsList, selecting, updateOrientation } = this.props;
    const { startOfWeek, endOfWeek } = this.state;
    return (
      <div>
        <div className='week-number'>
          <div
            className='change-week-arrow'
            onClick={this.showPreviousWeek}
          >
            <FontAwesomeIcon icon={faChevronLeft} size='lg' />
          </div>
          <p>{`${startOfWeek.format(dashboardNavDateFormat)} - ${endOfWeek.format(dashboardNavDateFormat)}`}</p>
          <div
            className='change-week-arrow'
            onClick={this.showNextWeek}
          >
            <FontAwesomeIcon icon={faChevronRight} size='lg' />
          </div>
        </div>
        <div className='board-wrapper'>
          {orientationsList.map(weekDayData => (
            <OrientationsColumn
              key={weekDayData.date}
              date={weekDayData.date}
              orientations={weekDayData.orientations}
              selecting={selecting}
              updateOrientation={updateOrientation}
            />
          ))}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    orientationsList: state.orientations.orientationsList
  };
};

const mapDispatchToProps = {
  getOrientationsList
};

export default connect(mapStateToProps, mapDispatchToProps)(OrientationsList);



// WEBPACK FOOTER //
// ./src/components/app/orientations/OrientationsList/index.js